import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faExclamationTriangle } from "@fortawesome/free-solid-svg-icons";

const Alert = (props) => (
  <div className="BookingInformation-error">
    <div className={`alert alert-${props.type || "warning"}`}>
      <FontAwesomeIcon icon={faExclamationTriangle} /> {props.message}
      {props.messageValue ? <hr /> : null}
      {props.messageValue ? (
        <div className={"mt-2 small"}>{props.messageValue}</div>
      ) : null}
    </div>
  </div>
);

export default Alert;
